import Table from '@components/table';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import moment from 'moment/moment';
import { ETicketStatus } from '@xeppt/xeppt-sdk/types';
import Status from '@components/common/status';
import { capitalizeFirstLetter, getTicketStatusVariant } from '@utils/index';
import { useSupport } from '@hooks/api/useSupport';

const TicketsLayout = () => {
    const { tickets } = useSupport({
        isInitialGetList: true
    });

    const columns = [
        {
            label: 'ID',
            key: 'id'
        },
        {
            label: 'Subjects',
            key: 'subject'
        },
        {
            label: 'Created',
            key: 'created_at',
            render: (value: Date) => value && moment(value).format('MM.DD.YYYY, HH:mm')
        },
        {
            label: 'Updated',
            key: 'updated_at',
            render: (value: Date) => value && moment(value).format('MM.DD.YYYY, HH:mm')
        },
        {
            label: 'Assignee',
            key: 'assignee_id'
        },
        {
            label: 'Status',
            key: 'status',
            render: (val: ETicketStatus) => (
                <Status variant={getTicketStatusVariant(val)}>{capitalizeFirstLetter(val)}</Status>
            )
        }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.text_wrapper}>
                    <Typography variant="h4">Tickets</Typography>
                    <Typography>{tickets?.total} records found</Typography>
                </div>
                {/*<div className={styles.actions}>*/}
                {/*    <RangeDatePicker*/}
                {/*        className={styles.date}*/}
                {/*        placeholder="Select a date range requested"*/}
                {/*    />*/}
                {/*    <RangeDatePicker*/}
                {/*        className={styles.date}*/}
                {/*        placeholder="Select a date range updated"*/}
                {/*    />*/}
                {/*    <Input*/}
                {/*        className={styles.search}*/}
                {/*        placeholder="Search by ID, subject, requester or assigne..."*/}
                {/*        leftIcon="search"*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <Table
                //@ts-ignore
                columns={columns}
                rows={tickets?.data || []}
                onFilterChange={() => {}}
                totalRows={0}
                emptyDescription="Tickets list is empty"
            />
        </div>
    );
};

export default TicketsLayout;
